import axios from 'axios'
import Promise from 'bluebird'

const client = axios.create({
  baseURL: process.env.API_URL || '/api-www'
})

client.Promise = Promise

client.interceptors.response.use(response => {
  return response
}, error => {
  if(error.response && error.response.status === 403 && typeof window !== 'undefined'){
    window.location.reload()
    return
  }
  return Promise.reject(error)
})

const server = {
  client,

  searchRecipes(params){
    return client.get(`/search`, { params })
    .then(result => result.data)
  },

  createRating(rating, params){
    return client.post(`/user/ratings`, {rating}, { params })
    .then(result => result.data)
  },

  getRating(params){
    return client.get(`/user/ratings`, { params })
    .then(result => result.data)
  },


  getComments(params){
    return client.get(`/comments`, { params })
    .then(result => result.data)
  },

  createComment(comment, params){
    return client.post(`/user/comments`, {comment}, { params })
    .then(result => result.data)
  },


  addShoppingItem(data){
    return client.post(`/user/shopping`, data)
    .then(result => result.data)
  }
}


export default function install(Vue) {
  if (install.installed) return
  install.installed = true

  Object.defineProperty(Vue.prototype, '$api', {
    get(){
      if(!this.$root.$options.api) return
      return this.$root.$options.api.api
    }
  })
}

install.api = server



// WEBPACK FOOTER //
// ./src/api.js